import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dk-pafta-ada-parsel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pafta-ada-parsel.component.html',
  styleUrls: ['./pafta-ada-parsel.component.scss'],
})
export class PaftaAdaParselComponent {}
